<template>
  <div>
    <div
      class="flex items-center p-2 cursor-pointer hover:bg-background rounded-md"
      @click="$emit('toggle')"
    >
      <Avatar
        :entity="{ id: root.id, text: root.name }"
        class="mr-3 shrink-0"
        size="lg"
      />
      <span class="truncate font-medium text-base grow">{{ root.name }}</span>
      <SvgIcon
        icon="ArrowDown"
        class="text-secondary shrink-0 ml-2 transition-transform"
        :class="{ 'rotate-180': expanded }"
      />
    </div>

    <ExpandTransition :show="expanded">
      <div>
        <AccountOption
          v-for="entityItem in entities"
          :key="entityItem.id"
          :id="`enter-admin-view-${entityItem.id}`"
          class="pl-5"
          nested
          @click="() => $emit('select', entityItem.id)"
        >
          <template #icon>
            <SvgIcon icon="Box" class="text-brand mr-3 shrink-0" />
          </template>
          {{ entityItem.name }}
        </AccountOption>
      </div>
    </ExpandTransition>
  </div>
</template>

<script setup lang="ts">
import Avatar from '@/components/misc/Avatar'
import SvgIcon from '@/components/misc/SvgIcon'
import ExpandTransition from '@/components/misc/ExpandTransition'
import AccountOption from './AccountOption.vue'
import type { Entity, Root } from '@/types/services/root'

defineProps<{
  root: Root
  entities: Entity[]
  expanded: boolean
}>()

defineEmits<{
  (e: 'select', entityId: string): void
  (e: 'toggle'): void
}>()
</script>
